import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import siteLogo from "../assets/images/site-logo.svg";

interface NavbarProps {
  className?: string;
}

const Navbar: React.FC<NavbarProps> = ({ className = "" }) => {
  const { user, logout, userRole } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const userName = user?.email ? user.email.split("@")[0] : "User";
  // Logout handler
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // On mobile, close the menu after clicking
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  // Custom link component that scrolls to top
  const NavLink = ({
    to,
    children,
    ...props
  }: {
    to: string;
    children: React.ReactNode;
    className?: string;
    target?: string;
  }) => (
    <Link to={to} onClick={scrollToTop} {...props}>
      {children}
    </Link>
  );

  const NavItems = React.memo(() => (
    <>
      {user ? (
        <>
          <ul className={`${isMenuOpen ? "active" : ""}`}>
            <li className="rightItem">
              <NavLink to="" className="adminIcon">
                Admin
              </NavLink>
              <ul>
                {/* {userRole === "admin" && (
                  <li
                    className={location.pathname === "/admin" ? "active" : ""}
                  >
                    <NavLink to="/admin">Admin</NavLink>
                  </li>
                )} */}
                <li>
                  <button onClick={handleLogout} className="headerUser">
                    Logout
                    {window.location.hostname === "admin.fantasyloser.com"
                      ? ""
                      : ` - ${userName}`}
                  </button>
                </li>
              </ul>
            </li>
          </ul>
          <span
            className={`${isMenuOpen ? "menuIcon active" : "menuIcon"}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            Menu Icon
          </span>
        </>
      ) : (
        ""
      )}
    </>
  ));

  return (
    <div className="topHeader">
      <div className="wrapper">
        <Link to={user ? "/admin" : "/"} className="siteLogo" onClick={scrollToTop}>
          <img src={siteLogo} alt="FL Logo" />
        </Link>
        <nav className="topNav">
          <NavItems />
        </nav>
      </div>
    </div>
  );
};

export default React.memo(Navbar);
